import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import enhance from './ViewProposal.enhancer';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import Button from '@material-ui/core/Button';
import LinkText from '../../../components/shared/components/LinkText';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import { orderBy } from 'lodash';

class ViewProposal extends React.Component {
  constructor() {
    super();

    this.initialState = {
      showProgressSpinner: false,
      allProposals: [],
      tabValue: 0,
      currentIndex: 0,
      test: false
    };

    this.state = {
      ...this.initialState
    };
  }
  closeDrawer() {
    this.props.closeClick();
  }

  handleNavigateToMessages() {
    this.closeDrawer();
    this.props.history.push(`/messages`);
  }

  handleProposeDealClick() {
    this.closeDrawer();
    this.props.handleProposeDeal(this.props.deal);
  }

  requestRevision(dealId) {
    this.closeDrawer();
    this.props.revisionRequestHandler(dealId, this.props.auth.uid);
  }

  acceptDeal(dealId) {
    this.setState({
      showProgressSpinner: true
    });
    this.props.acceptDealHandler(
      dealId,
      this.props.auth.uid,
      this.onAcceptComplete
    );
  }

  onAcceptComplete = () => {
    this.setState({
      showProgressSpinner: false
    });
    this.props.onDealAcceptComplete(this.props.deal);
    this.closeDrawer();
  };

  navigateToDealsPage() {
    this.closeDrawer();
    this.props.history.push(`/deals`);
  }

  viewPreviousProposalClick = async () => {
    const allProposalsSnapshots = await this.props.firestore
      .collection('deals')
      .doc(this.props.deal.id)
      .collection('proposals')
      .get();

    const proposalDocs = allProposalsSnapshots.docs.map(propSnap => {
      return { ...propSnap.data(), id: propSnap.id };
    });

    this.setState({
      // allProposals: orderBy(proposalDocs, ['timestamp'], ['desc'])
      allProposals: proposalDocs
    });
  };

  handleTabChange(event, newValue) {
    if (newValue === 1) {
      this.viewPreviousProposalClick();
    }
    this.setState({
      tabValue: newValue
    });
  }

  handleChangeIndex(index) {
    this.setState({
      currentIndex: index
    });
  }

  openExpansionPanel(event, name) {
    this.setState({
      // name: !this.state[name]
      test: !this.state.test
    });
  }

  render() {
    const { classes, open, deal, showButtons, auth, profile } = this.props;
    const { showProgressSpinner, tabValue, allProposals } = this.state;

    let dueDate;
    if (deal && deal.currentProposal) {
      const date = deal.currentProposal.dueDate.toDate();

      dueDate = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
    }

    return (
      <Drawer onClose={this.closeDrawer.bind(this)} anchor="right" open={open}>
        <Tabs
          value={tabValue}
          onChange={this.handleTabChange.bind(this)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Current Proposal" />
          <Tab label="All Proposals" />
        </Tabs>
        <SwipeableViews
          index={tabValue}
          onChangeIndex={this.handleChangeIndex}
          className={classes.swipeableViews}
        >
          <Grid>
            {deal && deal.currentProposal && (
              <div className={classes.list} role="presentation">
                <Grid
                  container
                  direction="column"
                  align="center"
                  className={classes.gridContainer}
                >
                  <Typography
                    variant="h4"
                    className={classes.title}
                    align="center"
                    justify="center"
                  >
                    Deal Details
                  </Typography>
                  <Divider />
                  <Grid
                    container
                    direction="row"
                    sm={12}
                    className={classes.contentSection}
                    align="left"
                  >
                    <StoreMallDirectoryIcon className={classes.icon} />
                    <Typography variant="body1" display="inline">
                      {deal.campaign.name}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    sm={12}
                    className={classes.contentSection}
                    align="left"
                  >
                    <DateRangeIcon className={classes.icon} />
                    <Typography variant="body1" display="inline">
                      {dueDate}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    sm={12}
                    className={classes.contentSection}
                    align="left"
                  >
                    <CardGiftcardIcon className={classes.icon} />
                    <Typography variant="body1" display="inline">
                      {deal.currentProposal.commissionOnly && 'Commission Only'}
                      {deal.currentProposal.productAndCommission &&
                        'Product and Commission'}
                      {deal.currentProposal.productOnly && 'Product only'}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    sm={12}
                    className={classes.contentSection}
                    align="left"
                  >
                    <AttachMoneyIcon className={classes.icon} />
                    <Typography variant="body1">
                      {deal.currentProposal.payout.toLocaleString()}
                    </Typography>
                  </Grid>
                  <div className={classes.contentSection}>
                    <Typography variant="h6">Commission Details</Typography>
                    <Divider />
                    <Typography variant="body1">
                      {deal.currentProposal.commissionDetails}
                    </Typography>
                  </div>
                  <div className={classes.contentSection}>
                    <Typography variant="h6">Content Details</Typography>
                    <Divider />
                    <Typography variant="body1">
                      {deal.currentProposal.contentDetails}
                    </Typography>
                  </div>
                  <div className={classes.contentSection}>
                    <Typography variant="h6">
                      Product Deliverable Details
                    </Typography>
                    <Divider />
                    <Typography variant="body1">
                      {deal.currentProposal.productDeliverableDetails}
                    </Typography>
                  </div>
                  {showButtons && (
                    <div className={classes.contentSection}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth={true}
                        className={classes.acceptButton}
                        onClick={() => this.acceptDeal(deal.id)}
                      >
                        Accept
                      </Button>
                      <Button
                        color="primary"
                        fullWidth={true}
                        className={classes.contentSection}
                        onClick={() => this.handleProposeDealClick()}
                      >
                        Revise Proposal
                      </Button>
                      <Button
                        // variant="contained"
                        color="primary"
                        fullWidth={true}
                        className={classes.contentSection}
                        onClick={() => this.handleNavigateToMessages()}
                      >
                        Message
                      </Button>
                    </div>
                  )}
                </Grid>
              </div>
            )}
            {deal && !deal.currentProposal && (
              <div className={classes.list} role="presentation">
                <Grid
                  container
                  direction="column"
                  align="center"
                  className={classes.gridContainer}
                >
                  <Typography>No current proposal</Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth={true}
                    className={classes.acceptButton}
                    onClick={() => this.handleProposeDealClick(deal)}
                  >
                    Propose a Deal
                  </Button>
                </Grid>
              </div>
            )}
          </Grid>
          <Grid
            container
            direction="column"
            className={classes.pastProposalsContainer}
          >
            {allProposals &&
              allProposals.length > 0 &&
              allProposals.map((proposal, index) => (
                <ExpansionPanel>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={proposal.id}
                    id={proposal.id}
                  >
                    {proposal.timestamp
                      ? moment(proposal.timestamp.toDate()).format(
                          'MM/DD/YYYY hh:mm'
                        )
                      : ''}
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Grid container direction="column">
                      <div className={classes.detailsRow}>
                        <Typography
                          display="inline"
                          className={classes.detailTitle}
                        >
                          Sender:
                        </Typography>
                        <Typography variant="body1" display="inline">
                          {profile.isCompany && auth.uid === proposal.sender
                            ? ' Company'
                            : ''}
                          {profile.isCompany && auth.uid !== proposal.sender
                            ? ' Influencer'
                            : ''}
                          {!profile.isCompany && auth.uid === proposal.sender
                            ? ' Influencer'
                            : ''}
                          {!profile.isCompany && auth.uid !== proposal.sender
                            ? ' Company'
                            : ''}
                        </Typography>
                      </div>
                      <div className={classes.detailsRow}>
                        <Typography
                          display="inline"
                          className={classes.detailTitle}
                        >
                          Deal Type:
                        </Typography>
                        <Typography variant="body1" display="inline">
                          {proposal.commissionOnly && ' Commission Only'}
                          {proposal.productAndCommission &&
                            ' Product and Commission'}
                          {proposal.productOnly && ' Product only'}
                        </Typography>
                      </div>
                      <div className={classes.detailsRow}>
                        <Typography
                          display="inline"
                          className={classes.detailTitle}
                        >
                          Payout:
                        </Typography>
                        <Typography variant="body1" display="inline">
                          {` $${proposal.payout}`}
                        </Typography>
                      </div>
                      <div className={classes.detailsRow}>
                        <Typography
                          display="inline"
                          className={classes.detailTitle}
                        >
                          Commission Details:
                        </Typography>
                        <Typography variant="body1" display="inline">
                          {` ${proposal.commissionDetails}`}
                        </Typography>
                      </div>
                      <div className={classes.detailsRow}>
                        <Typography
                          display="inline"
                          className={classes.detailTitle}
                        >
                          Content Details:
                        </Typography>
                        <Typography variant="body1" display="inline">
                          {` ${proposal.contentDetails}`}
                        </Typography>
                      </div>
                      <div className={classes.detailsRow}>
                        <Typography
                          display="inline"
                          className={classes.detailTitle}
                        >
                          Product Deliverable Details:
                        </Typography>
                        <Typography variant="body1" display="inline">
                          {` ${proposal.productDeliverableDetails}`}
                        </Typography>
                      </div>
                    </Grid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
            {(!allProposals || (allProposals && allProposals.length === 0)) && (
              <Grid className={classes.noPastProposals}>
                <Typography align="center" justify="center">
                  No past proposals
                </Typography>
              </Grid>
            )}
          </Grid>
        </SwipeableViews>
        {showProgressSpinner && (
          <div className={classes.spinnerContainer}>
            <CircularProgress className={classes.downArrow} />
          </div>
        )}
      </Drawer>
    );
  }
}

export default enhance(ViewProposal);



// WEBPACK FOOTER //
// ./src/components/deals/proposals/ViewProposal.js